import { StyleSheet } from 'react-native';

import { AutoGrowInput, shadows } from '@pletly/ui';
import { MentionInputProps } from './MentionInputProps';

/**
 *  @TODO handle real mention suggestions as in native version
 */

export const MentionInput = ({ onChangeText, ...inputProps }: MentionInputProps) => {
	return (
		<AutoGrowInput
			multiline
			onChangeText={onChangeText}
			{...inputProps}
			style={[styles.root, inputProps.style]}
			textStyle={styles.textStyle}
		/>
	);
};

const styles = StyleSheet.create({
	root: { borderWidth: 0, ...shadows.reset },
	textStyle: {
		maxHeight: 300,
	},
});
